import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.GREEN_YELLOW,
    codeProp: 'fcUserCode',
    detailIdProp: 'fcId',
    detailUrl: '/FcDetail',
    listUrl: '/FcList',
    mapProp: 'fcMap',
    name: '程序能力',
    textProp: 'fcName',
    type: 'FC',
}
